"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSchema = void 0;
const errors_1 = require("./errors");
const parseOneOf_1 = require("./parseOneOf");
const parseType_1 = require("./parseType");
const common_tags_1 = require("common-tags");
const toBreadcrumb_1 = require("./toBreadcrumb");
const toPascalCase_1 = require("./toPascalCase");
const parseSchema = function ({ path, schema, direction }) {
    let result;
    if (schema.type) {
        result = parseType_1.parseType({ path, schema, direction });
    }
    else if (schema.oneOf) {
        result = parseOneOf_1.parseOneOf({ path, schema, direction });
    }
    else {
        throw new errors_1.errors.SchemaInvalid(`Structure at '${toBreadcrumb_1.toBreadcrumb(path)}' not recognized.`);
    }
    if (result.typeName.includes('|')) {
        const typeName = toPascalCase_1.toPascalCase(path);
        result.typeDefinitions.push(common_tags_1.stripIndent `
      union ${typeName} = ${result.typeName}
    `);
        result.typeName = typeName;
    }
    return result;
};
exports.parseSchema = parseSchema;
